"use strict";

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var client_1 = __importDefault(require("./parsers/client"));

var device_1 = __importDefault(require("./parsers/device"));

var operating_system_1 = __importDefault(require("./parsers/operating-system"));

var vendor_fragment_1 = __importDefault(require("./parsers/vendor-fragment"));

var browser_1 = __importDefault(require("./parsers/client/browser"));

var BotParser = require("./parsers/bot");

var user_agent_1 = require("./utils/user-agent");

var version_compare_1 = require("./utils/version-compare");

var DeviceDetector = function DeviceDetector(options) {
  var _this = this;

  _classCallCheck(this, DeviceDetector);

  // Default options
  this.options = {
    skipBotDetection: false,
    versionTruncation: 1
  };

  this.parse = function (userAgent) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;

    var result = {
      client: _this.clientParser.parse(userAgent),
      os: _this.operatingSystemParser.parse(userAgent),
      device: _this.deviceParser.parse(userAgent),
      bot: _this.options.skipBotDetection ? null : _this.botParser.parse(userAgent)
    };
    var osName = (_a = result.os) === null || _a === void 0 ? void 0 : _a.name;
    var osVersion = (_b = result.os) === null || _b === void 0 ? void 0 : _b.version;
    var osFamily = operating_system_1.default.getOsFamily(osName || "");

    if (!((_c = result.device) === null || _c === void 0 ? void 0 : _c.brand)) {
      var brand = _this.vendorFragmentParser.parse(userAgent);

      if (brand) {
        if (!result.device) {
          result.device = _this.createDeviceObject();
        }

        result.device.brand = brand;
      }
    }
    /**
     * Assume all devices running iOS / Mac OS are from Apple
     */


    if (!((_d = result.device) === null || _d === void 0 ? void 0 : _d.brand) && ["Apple TV", "watchOS", "iOS", "Mac"].includes(osName || "")) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.brand = "Apple";
    }
    /**
     * Chrome on Android passes the device type based on the keyword 'Mobile'
     * If it is present the device should be a smartphone, otherwise it's a tablet
     * See https://developer.chrome.com/multidevice/user-agent#chrome_for_android_user_agent
     * Note: We do not check for browser (family) here, as there might be mobile apps using Chrome, that won't have
     *       a detected browser, but can still be detected. So we check the useragent for Chrome instead.
     */


    if (!((_e = result.device) === null || _e === void 0 ? void 0 : _e.type) && osFamily === "Android" && user_agent_1.userAgentParser("Chrome/[\\.0-9]*", userAgent)) {
      if (user_agent_1.userAgentParser("Chrome/[.0-9]* (?:Mobile|eliboM)", userAgent)) {
        if (!result.device) {
          result.device = _this.createDeviceObject();
        }

        result.device.type = "smartphone";
      } else if (user_agent_1.userAgentParser("Chrome/[.0-9]* (?!Mobile)", userAgent)) {
        if (!result.device) {
          result.device = _this.createDeviceObject();
        }

        result.device.type = "tablet";
      }
    }
    /**
     * Some user agents simply contain the fragment 'Android; Tablet;' or 'Opera Tablet', so we assume those devices are tablets
     */


    if (!((_f = result.device) === null || _f === void 0 ? void 0 : _f.type) && _this.hasAndroidTabletFragment(userAgent) || user_agent_1.userAgentParser("Opera Tablet", userAgent)) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.type = "tablet";
    }
    /**
     * Some user agents simply contain the fragment 'Android; Mobile;', so we assume those devices are smartphones
     */


    if (!((_g = result.device) === null || _g === void 0 ? void 0 : _g.type) && _this.hasAndroidMobileFragment(userAgent)) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.type = "smartphone";
    }
    /**
     * Android up to 3.0 was designed for smartphones only. But as 3.0, which was tablet only, was published
     * too late, there were a bunch of tablets running with 2.x
     * With 4.0 the two trees were merged and it is for smartphones and tablets
     *
     * So were are expecting that all devices running Android < 2 are smartphones
     * Devices running Android 3.X are tablets. Device type of Android 2.X and 4.X+ are unknown
     */


    if (!((_h = result.device) === null || _h === void 0 ? void 0 : _h.type) && osName === "Android" && osVersion !== "") {
      if (version_compare_1.versionCompare(osVersion, "2.0") === -1) {
        if (!result.device) {
          result.device = _this.createDeviceObject();
        }

        result.device.type = "smartphone";
      } else if (version_compare_1.versionCompare(osVersion, "3.0") >= 0 && version_compare_1.versionCompare(osVersion, "4.0") === -1) {
        if (!result.device) {
          result.device = _this.createDeviceObject();
        }

        result.device.type = "tablet";
      }
    }
    /**
     * All detected feature phones running android are more likely smartphones
     */


    if (((_j = result.device) === null || _j === void 0 ? void 0 : _j.type) === "feature phone" && osFamily === "Android") {
      result.device.type = "smartphone";
    }
    /**
     * According to http://msdn.microsoft.com/en-us/library/ie/hh920767(v=vs.85).aspx
     * Internet Explorer 10 introduces the "Touch" UA string token. If this token is present at the end of the
     * UA string, the computer has touch capability, and is running Windows 8 (or later).
     * This UA string will be transmitted on a touch-enabled system running Windows 8 (RT)
     *
     * As most touch enabled devices are tablets and only a smaller part are desktops/notebooks we assume that
     * all Windows 8 touch devices are tablets.
     */


    if (!((_k = result.device) === null || _k === void 0 ? void 0 : _k.type) && _this.isToucheEnabled(userAgent) && (osName === "Windows RT" || osName === "Windows" && version_compare_1.versionCompare(osVersion, "8.0") >= 0)) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.type = "tablet";
    }
    /**
     * All devices running Opera TV Store are assumed to be televisions
     */


    if (user_agent_1.userAgentParser("Opera TV Store", userAgent)) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.type = "television";
    }
    /**
     * Devices running Kylo or Espital TV Browsers are assumed to be televisions
     */


    if (!((_l = result.device) === null || _l === void 0 ? void 0 : _l.type) && ["Kylo", "Espial TV Browser"].includes(((_m = result.client) === null || _m === void 0 ? void 0 : _m.name) || "")) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.type = "television";
    } // set device type to desktop for all devices running a desktop os that were not detected as an other device type


    if (!((_o = result.device) === null || _o === void 0 ? void 0 : _o.type) && _this.isDesktop(result, osFamily)) {
      if (!result.device) {
        result.device = _this.createDeviceObject();
      }

      result.device.type = "desktop";
    }

    return result;
  };

  this.hasAndroidMobileFragment = function (userAgent) {
    return user_agent_1.userAgentParser("Android( [\.0-9]+)?; Mobile;", userAgent);
  };

  this.hasAndroidTabletFragment = function (userAgent) {
    return user_agent_1.userAgentParser("Android( [\.0-9]+)?; Tablet;", userAgent);
  };

  this.isDesktop = function (result, osFamily) {
    if (!result.os) {
      return false;
    } // Check for browsers available for mobile devices only


    if (_this.usesMobileBrowser(result.client)) {
      return false;
    }

    return operating_system_1.default.getDesktopOsArray().includes(osFamily);
  };

  this.usesMobileBrowser = function (client) {
    var _a, _b;

    if (!client) return false;
    return ((_a = client) === null || _a === void 0 ? void 0 : _a.type) === "browser" && browser_1.default.isMobileOnlyBrowser((_b = client) === null || _b === void 0 ? void 0 : _b.name);
  };

  this.isToucheEnabled = function (userAgent) {
    return user_agent_1.userAgentParser("Touch", userAgent);
  };

  this.createDeviceObject = function () {
    return {
      type: "",
      brand: "",
      model: ""
    };
  };

  this.options = Object.assign(Object.assign({}, this.options), options);
  this.clientParser = new client_1.default(this.options);
  this.deviceParser = new device_1.default();
  this.operatingSystemParser = new operating_system_1.default(this.options);
  this.vendorFragmentParser = new vendor_fragment_1.default();
  this.botParser = new BotParser();
};

module.exports = DeviceDetector;